export const LAZY_MODULES_MODULE = [
    '@lazy-modules-module/racingFeatured/racing-featured.module',
    '@lazy-modules-module/competitionsSportTab/competitionsSportTab.module',
    '@lazy-modules-module/forecastTricast/forecastTricast.module',
    '@lazy-modules-module/eventVideoStream/event-video-stream.module',
    '@lazy-modules-module/sortByOptions/sort-by-options.module',
    '@lazy-modules-module/superButton/super-button.module',
    '@lazy-modules-module/devLog/dev-log.module',
    '@lazy-modules-module/rpg/rpg.module',
    '@lazy-modules-module/quiz/quiz-dialog.module',
    '@lazy-modules-module/lazy-initializer-homepage/lazy-initializer-homepage.module',
    '@lazy-modules-module/receiptHeader/receipt-header.module',
    '@lazy-modules-module/bpmpFreeTokens/bpmp-tokens.module',
    '@lazy-modules-module/betpackOnboarding/betpack-onboarding.module',
    '@lazy-modules-module/betRadarProvider/bet-radar.module',
    '@lazy-modules-module/runnerSpotlight/runner-spotlight.module',
    '@lazy-modules-module/market-description/market-description.module',
    '@lazy-modules-module/racingPostVerdict/racing-post-verdict.module',
    '@lazy-modules-module/nextRacesToBetslip/nextraces-to-betslip.module',
    '@lazy-modules-module/racingPostTip/racing-post-tip.module',
    '@lazy-modules-module/banners/banners.module',
    '@lazy-modules-module/fiveASideShowDown/fiveaside-entry-confirmation.module',
    '@lazy-modules-module/timeline/timeline.module',
    '@lazy-modules-module/racingMyBets/racing-mybets.module',
    '@lazy-modules-module/maxpayOutErrorContainer/maxpayout-error-container.module',
    '@lazy-modules-module/freeRide/freeRide.module',
    '@lazy-modules-module/competitionFilters/competitionFilters.module',
    '@lazy-modules-module/racesMeetingsOverlay/racing-meetings.module',
    '@lazy-modules-module/raceCard/race-card-content.module',
    '@lazy-modules-module/fanzone/fanzone-shared.module',
    '@lazy-modules-module/aToZMenu/az-sports-page.module',
    '@lazy-modules-module/maxpayOutErrorContainer/maxpayout-error-container.module',
    '@lazy-modules-module/listTemplate/list-template.module',
    '@lazy-modules-module/customFlagFiltertoggle/custom-flag-filter-toggle.module',
    '@lazy-modules-module/multiMarketTemplate/multi-market-template.module',
    '@lazy-modules-module/quickLinks/quick-links.module',
    '@lazy-modules-module/nextRaces/next-races.module',
    '@lazy-modules-module/floating-ihr-msg/floating-ihr-msg.module',
    '@lazy-modules-module/racingStatus/racing-status.module',
    '@lazy-modules-module/couponsModule/coupons.module',
    '@lazy-modules-module/footerMenu/footer-menu.module',
    '@lazy-modules-module/racingEventModel/racing-event-model.module',
    '@lazy-modules-module/raceMarket/race-market.module',
    '@lazy-modules-module/onBoardingTutorial/firstBetPlacement/first-bet-placement.module',
    '@lazy-modules-module/coupon-stat-widget/coupon-stat-widget.module',
    '@lazy-modules-module/onBoardingTutorial/firstBetPlacement/first-bet-placement.module',
    '@lazy-modules-module/InplayHRHeader/inplay-hr-header.module',
    '@lazy-modules-module/InPlaySportTab/in-play-sport-tab.module',
    '@lazy-modules-module/racingEventModel/racing-event-model.module',
    '@lazy-modules-module/racingFullResults/racing-full-results.module',
    '@lazy-modules-module/extraPlaceSignposting/extra-place-signposting.module',
    '@lazy-modules-module/raceCardInplay/race-card-inplay.module',
    '@lazy-modules-module/twoUpSignpostingBlurbMsg/twoup-signposting-blurbmsg.module',
    '@lazy-modules-module/signposting/signposting.module',
    '@lazy-modules-module/lazyNextRacesTab/lazyNextRacesTab.module',
    '@lazy-modules-module/bet-share-image-card/bet-share-image-card.module',
    '@lazy-modules-module/lottoBetSlip/lotto-betslip.module',
    '@lazy-modules-module/statisticalContentInformation/statistical-content-information.module',
    '@lazy-modules-module/luckyDip/luckyDip.module',
    '@lazy-modules-module/sidebar/sidebar.module',
    '@lazy-modules-module/carouselMenu/carousel-menu.module',
    '@lazy-modules-module/promoLeaderboard/promo-leaderboard.module',
    '@lazy-modules-module/home-screen/home-screen.module',
    '@lazy-modules-module/myStableEdp/mystable-edp.module',
    '@lazy-modules-module/myStableCarousel/mystable-carousel.module',
    '@lazy-modules-module/myStableRacingModule/mystable-racing.module',
    '@lazy-modules-module/racingLazy/racing-lazy.module',
    '@lazy-modules-module/profit-indicator/profit-indicator.module',
    '@lazy-modules-module/toteFreeBets/toteFreeBets.module',
    '@lazy-modules-module/stream-bet-tutorial-pop-up/stream-bet-tutorial-pop-up.module',
    '@lazy-modules-module/eventQuickSwitch/quick-switch.module',
    '@lazy-modules-module/insightsTab/insights.module',
    '@lazy-modules-module/betslipBar/betslip-bar.module',
    '@lazy-modules-module/insightsTab/insights.module',
    '@lazy-modules-module/trending-bets-carousel/trending-bets-carousel.module',
    '@lazy-modules-module/fzPopularBets/fz-popular-bets.module',
    '@lazy-modules-module/virtualNextEvents/virtual-next-events.module',
    '@lazy-modules-module/mystable-crc-racealert-onboarding/mystable-crc-racealert.module',
    '@lazy-modules-module/popularBetsModule/popular-bets.module',
    '@lazy-modules-module/more-link/more-link.module',
    '@lazy-modules-module/bybWidget/featured-byb-widget.module',
    '@lazy-modules-module/oddsCardStatsModule/odds-card-stats.module',
    '@lazy-modules-module/betFilters/bet-filters.module',
    '@lazy-modules-module/inplay-stat-widget/inplay-stat-widget.module',
    '@lazy-modules-module/bybLabel/byb-label.module',
    '@lazy-modules-module/luckyDip/lucky-dip-lazy.module',
    '@lazy-modules-module/odds-boost-msg/odds-boost-msg.module',
    '@lazy-modules-module/scoreCard/score-card.module',
    '@lazy-modules-module/oddsCardInplayLazy/odds-card-inplay-lazy.module',
    '@lazy-modules-module/historicPricesLazy/historic-prices-lazy.module',
    '@lazy-modules-module/inplayScoreLazy/inplay-score-lazy.module',
    '@lazy-modules-module/crestImage/crest-image.module',
    '@lazy-modules-module/oddsCardSpecialsLazy/odds-card-specials-lazy.module',
    '@lazy-modules-module/priceBoostModule/price-boost.module',
    '@lazy-modules-module/edpPriceBoostModule/edp-price-boost.module',
    '@lazy-modules-module/singlePriceBoostModule/single-price-boost.module',
    '@lazy-modules-module/quaccabar/quaccabar.module',
];

export const OTHER_MODULES = [
    '@lazy-modules/locale/translation.module',
    '@app/stats/stats.module',
    '@uktote-lazy-load/uk-tote.module',
    '@lazy-modules/gamingOverlay/gaming-overlay.module',
    '@yourCallModule/your-call.module',
    '@oddsBoostModule/odds-boost.module',
    '@racingModule/racing.module',
    '@retail-lazy-load/retail.module',
    '@betHistoryModule/bet-history.module',
    '@featuredModule/featured.module',
    '@toteModule/tote.module',
    '@betslipModule/betslip.module',
    '@rightColumnModule/right-column.module',
    '@bybHistoryModule/byb-history.module',
    '@quickbetModule/quickbet.module',
    '@edpModule/edp.module',
    '@inplayModule/inplay.module',
    '@freebetsModule/freebets.module',
    '@quickDepositModule/quick-deposit.module',
    '@fiveASideShowDownModule/fiveASideShowDown.module',
    '@lazy-modules/seoStaticBlock/seo-static-block.module',
    '@sharedModule/components/marketSelector/market-selector.module',
    '@rightColumnModule/right-column.module',
    '@bybHistoryModule/byb-history.module',
    '@specialsModule/specials-sport-tab.module',
    '@lazy-modules-module/casinoMyBetsIntegration/casino-my-bets-integration.module',
    '@sharedModule/components/oddsCard/oddsCardHightlightCarousel/odds-card-highligt-carousel.module',
    '@lazy-modules-module/lazyPromotionIcons/lazy-promotion-icons.module',
    '@betpackModule/betpack-market.module',
    '@lazy-modules/couponsModule/lcoupons.module',
    '@lazy-modules/networkIndicator/network-indicator.module',
    '@sharedModule/components/moduleRibbon/module-ribbon.module',
    '@inPlayLiveStream/inplay-live-stream.module',
    '@quickbetStreamBetModule/sb-quickbet.module',
    '@sharedModule/components/liveClock/live-clock.module',
];

export const CD_MODULES = [
    '@lazy-modules-module/banners/banners.module',
    '@edpModule/edp.module',
    '@featuredModule/featured.module',
    '@lazy-modules-module/coupon-stat-widget/coupon-stat-widget.module',
    '@lazy-modules-module/multiMarketTemplate/multi-market-template.module',
    '@lazy-modules-module/oddsCardInplayLazy/odds-card-inplay-lazy.module',
    '@lazy-modules-module/oddsCardSpecialsLazy/odds-card-specials-lazy.module',
    '@lazy-modules-module/raceMarket/race-market.module',
    '@lazy-modules-module/racingFeatured/racing-featured.module',
    '@lazy-modules-module/racingLazy/racing-lazy.module',
    '@lazy-modules-module/racingPostVerdict/racing-post-verdict.module',
    '@lazy-modules-module/runnerSpotlight/runner-spotlight.module',
    '@lazy-modules-module/virtualNextEvents/virtual-next-events.module',
    '@sharedModule/components/marketSelector/market-selector.module',
    '@yourCallModule/your-call.module',
    '@lazy-modules-module/raceMarket/race-market.module',
    '@toteModule/tote.module',
    '@inplayModule/inplay.module',
    '@lazy-modules-module/racingEventModel/racing-event-model.module',
    '@featuredModule/featured.module',
    '@rightColumnModule/right-column.module',
    '@yourCallModule/your-call.module',
    '@inPlayLiveStream/inplay-live-stream.module',
    '@lazy-modules-module/raceCard/race-card-content.module',
    '@lazy-modules-module/carouselMenu/carousel-menu.module',
    '@sharedModule/components/marketSelector/market-selector.module',
    '@lazy-modules-module/InPlaySportTab/in-play-sport-tab.module',
    '@lazy-modules-module/competitionsSportTab/competitionsSportTab.module',
];
